import { render, staticRenderFns } from "./department-tree-choose.vue?vue&type=template&id=552342b7&"
import script from "./department-tree-choose.vue?vue&type=script&lang=js&"
export * from "./department-tree-choose.vue?vue&type=script&lang=js&"
import style0 from "./department-tree-choose.vue?vue&type=style&index=0&id=552342b7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports